export class MaterialComponentCandidate {
    constructor(item: any) {
        this.componentMaterialId		        = item.ComponentMaterialId;
        this.componentPrincipalName             = item.ComponentPrincipalName;
        this.compositionMaterialId              = item.CompositionMaterialId;
        this.componentCASNumber                 = item.ComponentCASNumber;
        this.compositionMaterialPrincipalName   = item.CompositionMaterialPrincipalName;
        this.itemCode                           = item.ItemCode;
        this.validationDate                     = (item.ValidationDate != null) ? new Date(item.ValidationDate) : null;
        this.componentPercentage		        = item.ComponentPercentage;
        this.statusMessage		                = item.StatusMessage;
        this.errorsFound			            = item.ErrorsFound;
        this.componentIsRIFMMaterial	        = item.ComponentIsRIFMMaterial;
        this.compositionMaterialIsRIFMMaterial  = item.CompositionMaterialIsRIFMMaterial;
        this.componentAlreadyAssignedToMixture  = item.ComponentAlreadyAssignedToMixture;
    }

    componentMaterialId: number;
    componentPrincipalName: string;
    compositionMaterialId: number;
    componentCASNumber: string;
    compositionMaterialPrincipalName: string;
    itemCode: string;
    validationDate: Date;
    componentPercentage: number;
    statusMessage: string;
    errorsFound: boolean;
    componentIsRIFMMaterial: boolean;
    compositionMaterialIsRIFMMaterial: boolean;
    componentAlreadyAssignedToMixture: boolean;
}
